module.exports = __webpack_public_path__ + "img/Albatross.bcc6a5df.png";